import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Blind extends Modifier {
  static readonly baseTitle = 'Blind';
  static readonly baseText = 'Reduce outgoing damage by half, then fade.';
  static readonly baseIcon = 'blind';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Late;

  // Instance properties that can change
  title = Blind.baseTitle;
  text = Blind.baseText;
  icon = Blind.baseIcon;
  tags: Array<ModifierTags> = [...Blind.baseTags];
  priority = Blind.basePriority;

  damageOut(damage: Damage) {
    damage.value = Math.max(1, Math.floor(damage.value / 2));
    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Blind, Blind);
